import React from 'react';

interface FuncParam {
  openFilePicker: () => void;
}

interface Props {
  id: string;
  children: (funcParam: FuncParam) => React.ReactNode;
  onFileSelect: (files: FileList) => void;
  accept: string;
  multiple: boolean;
}

class FileUpload extends React.Component<Props> {
  static defaultProps = {
    accept: '.pdf',
    multiple: true,
  };

  constructor(props: Props) {
    super(props);

    this.fileInputRef = React.createRef();
  }

  fileInputRef: React.RefObject<HTMLInputElement>;

  openFilePicker = (): void => {
    const fileInput = this.fileInputRef.current;

    if (fileInput) {
      fileInput.click();
    }
  };

  handleFileSelect = (): void => {
    const fileInput = this.fileInputRef.current;

    if (fileInput && fileInput.files) {
      this.props.onFileSelect(fileInput.files);
    }
  };

  render(): React.ReactNode {
    const { id, children, accept, multiple } = this.props;

    return (
      <>
        <input
          id={id}
          type="file"
          accept={accept}
          ref={this.fileInputRef}
          onChange={this.handleFileSelect}
          multiple={multiple}
          hidden
        />
        {children({ openFilePicker: this.openFilePicker })}
      </>
    );
  }
}

export default FileUpload;
